import deepMerge from 'deepmerge';
import { initI18n, Resource } from '@sunbit-dev/translations';

export const getTranslationResources = async ({ language }: { language: string }): Promise<{ namespaces: readonly string[]; resources: Resource }> => {
  const applicationTexts = await import(`~/i18n/locales/${language}/translation.json`);
  const purchaseCommonTexts = await import(`@sunbit-dev/purchase-common/src/i18n/locales/${language}/translation.json`);

  const resources = { [language]: deepMerge(purchaseCommonTexts, applicationTexts) };
  const namespaces = Object.keys(resources[language]);
  return { resources: resources as Resource, namespaces };
};

export const initTranslations = async ({ debug }: { debug: boolean }) => {
  return initI18n({
    debug,
    getResources: getTranslationResources,
  });
};
